// Iconos del marcador: los 4 botones de la tablet (rueda, audio, pantalla, pelota). Son trazados
// propios y rellenos en negro, como en el original, en vez de los iconos de línea del resto del panel.

export function IconoAjustes() {
  return (
    <svg viewBox="0 0 24 24" fill="#000" aria-hidden="true">
      <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.488.488 0 0 0-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />
    </svg>
  );
}

export function IconoAudio() {
  return (
    <svg viewBox="0 0 24 24" fill="#000" aria-hidden="true">
      <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 11h-3v3.75c0 1.24-1.01 2.25-2.25 2.25S8.5 17.99 8.5 16.75s1.01-2.25 2.25-2.25c.46 0 .89.14 1.25.38V11h4v2zm-3-4V3.5L18.5 9H13z" />
    </svg>
  );
}

export function IconoPantalla() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="2" y="3" width="20" height="14.5" rx="2.4" fill="#000" />
      <rect x="8.5" y="19" width="7" height="1.8" rx="0.9" fill="#000" />
      <g fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="square">
        <path d="M5.4 8V6.2h1.8" />
        <path d="M16.8 6.2h1.8V8" />
        <path d="M5.4 12.6v1.8h1.8" />
        <path d="M16.8 14.4h1.8v-1.8" />
      </g>
    </svg>
  );
}

export function IconoPelota() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="10.6" fill="#000" />
      <g fill="none" stroke="#fff" strokeWidth="1.7" strokeLinecap="round">
        <path d="M5.2 4.6c3.2 3.6 3.2 11.2 0 14.8" />
        <path d="M18.8 4.6c-3.2 3.6-3.2 11.2 0 14.8" />
      </g>
    </svg>
  );
}
